<template>
  <v-list-item-subtitle>
    <ApolloQuery
      :query="require('../graphql/queries/getUserKycStatus.graphql')"
      :variables="{
        userId,
      }"
    >
      <template v-slot="{ result: { error: kycError, data: kycData } }">
        <AppNotification
          v-if="kycError"
          :message="kycError.message"
        />
        <p>
          {{ kycData && kycData.getKycRequestsOfUser && kycData.getKycRequestsOfUser.requests && kycData.getKycRequestsOfUser.requests.length ? kycData.getKycRequestsOfUser.requests[0].status : 'no KYC' }}
        </p>
        <ApolloMutation
          :mutation="require('../graphql/mutations/setKycDecision.graphql')"
          :refetch-queries="refetchGetUserKycStatus"
          style="flex-direction: row; display: flex;"
        >
          <template v-slot="{ mutate: setKycDecision }">
            <v-btn
              v-if="!(kycData && kycData.getKycRequestsOfUser && kycData.getKycRequestsOfUser.requests && kycData.getKycRequestsOfUser.requests.length) || kycData.getKycRequestsOfUser.requests[0].status === 'DECLINED' || kycData.getKycRequestsOfUser.requests[0].status === 'AWAITING'"
              :color="'primary'"
              style="margin: auto"
              class="text-none"
              depressed
              height="36"
              small
              @click="openKycSubmissionForm()"
            >
              Заполнить KYC
            </v-btn>
            <v-btn
              v-if="kycData && kycData.getKycRequestsOfUser && kycData.getKycRequestsOfUser.requests && kycData.getKycRequestsOfUser.requests.length && kycData.getKycRequestsOfUser.requests[0].status === 'SUBMITTED'"
              :color="'primary'"
              :loading="loading"
              style="margin: auto"
              class="text-none"
              depressed
              height="36"
              small
              @click="setKycDecision({ variables: { kycRequestId: kycData.getKycRequestsOfUser.requests[0].id, approved: true } })"
            >
              Одобрить KYC
            </v-btn>
            <v-btn
              :loading="loading"
              style="margin: auto 1rem auto auto"
              class="text-none"
              depressed
              height="36"
              small
              :disabled="!(kycData && kycData.getKycRequestsOfUser && kycData.getKycRequestsOfUser.requests && kycData.getKycRequestsOfUser.requests.length && ['AWAITING', 'SUBMITTED'].includes(kycData.getKycRequestsOfUser.requests[0].status))"
              @click="setKycDecision({ variables: { kycRequestId: kycData.getKycRequestsOfUser.requests[0].id, approved: false } })"
            >
              Отклонить KYC
            </v-btn>
          </template>
        </ApolloMutation>
        <v-row v-if="kycData && kycData.getKycRequestsOfUser && kycData.getKycRequestsOfUser.requests && kycData.getKycRequestsOfUser.requests.length">
          <template>
            <v-col
              v-for="doc in kycData.getKycRequestsOfUser.requests[0].docs"
              :key="doc.id"
            >
              <img
                :src="doc.value"
                :style="{
                  width: '50px',
                }"
                @click="openKycDoc(doc.docId, doc.value)"
              >
              <p>{{ doc.docId }}</p>
            </v-col>
          </template>
        </v-row>
      </template>
    </ApolloQuery>
    <template>
      <v-dialog
        v-model="docOpened"
        max-width="1000px"
        persistent
      >
        <v-card>
          <v-card-title>{{ docId }}</v-card-title>
          <v-card-text>
            <img
              :src="docUrl"
              :style="{
                width: '100%',
                display: 'block',
              }"
              @click="closeKycDoc"
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer />

            <v-btn
              @click="closeKycDoc"
            >
              CLOSE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        v-model="kycSubmissionFormOpened"
        max-width="1000px"
        persistent
      >
        <ApolloQuery
          :query="require('../graphql/queries/checkKycBeforeWithdraw.graphql')"
          :variables="{
            userId,
          }"
          :update="setKycSubmissionFormParams"
        >
          <template v-slot="{ result: { error: kycError } }">
            <v-card v-if="kycSubmissionFormDocId && kycSubmissionFormDocsSetId">
              <AppNotification
                v-if="kycError"
                :message="kycError.message"
              />
              <v-card-title v-if="kycSubmissionFormDocId">
                {{ kycSubmissionFormDocsSetId }}: {{ kycSubmissionFormDocId }}
              </v-card-title>
              <v-card-text>
                <canvas
                  id="canvas"
                  style="display: block; width: 100%"
                />
                <v-file-input
                  id="file"
                  type="file"
                  accept="image/*"
                  label="Выберите файл для загрузки"
                  show-size
                  @change="onFileLoad"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />

                <v-btn
                  @click="uploadKycDoc"
                >
                  NEXT
                </v-btn>

                <v-btn
                  @click="closeKycSubmissionForm"
                >
                  CLOSE
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="kycSubmissionFormDocsSetId && !kycSubmissionFormDocId">
              <ApolloQuery
                :query="require('../graphql/queries/getKycDocsIdsForDocsSetId.graphql')"
                :variables="{
                  docsSetId: kycSubmissionFormDocsSetId,
                }"
              >
                <template v-slot="{ result: { error: kycError3, data: {getKycDocsIdsForDocsSetId} } }">
                  <AppNotification
                    v-if="kycError3"
                    :message="kycError3.message"
                  />
                  <v-card-title>
                    Выберите документ для загрузки
                  </v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="kycSubmissionFormDocId"
                      label="Документ для загрузки"
                      :items="getKycDocsIdsForDocsSetId"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <v-btn
                      @click="closeKycSubmissionForm"
                    >
                      CLOSE
                    </v-btn>
                  </v-card-actions>
                </template>
              </ApolloQuery>
            </v-card>
            <v-card v-if="!kycSubmissionFormDocsSetId && !kycSubmissionFormDocId">
              <ApolloQuery
                :query="require('../graphql/queries/getKycDocsSetsIds.graphql')"
              >
                <template v-slot="{ result: { error: kycError2, data: {getKycDocsSetsIds} } }">
                  <AppNotification
                    v-if="kycError2"
                    :message="kycError2.message"
                  />
                  <v-card-title>
                    Выберите набор документов для загрузки
                  </v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="kycSubmissionFormDocsSetId"
                      label="Набор документов для загрузки"
                      :items="getKycDocsSetsIds"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <v-btn
                      @click="closeKycSubmissionForm"
                    >
                      CLOSE
                    </v-btn>
                  </v-card-actions>
                </template>
              </ApolloQuery>
            </v-card>
          </template>
        </ApolloQuery>
      </v-dialog>
    </template>
  </v-list-item-subtitle>
</template>

<script>
import getUserKycStatus from '@/graphql/queries/getUserKycStatus.graphql';
import checkKycBeforeWithdraw from '@/graphql/queries/checkKycBeforeWithdraw.graphql';
import AppNotification from '@/components/AppNotification.vue';

function qualityRate(fileSize) {
  let QUALITY = 0.5;

  if (fileSize < 1000000) {
    QUALITY = 0.5;
  } else if (fileSize < 3000000) {
    QUALITY = 0.7;
  } else if (fileSize < 5000000) {
    QUALITY = 0.5;
  } else if (fileSize < 10000000) {
    QUALITY = 0.9;
  } else {
    QUALITY = 0.1;
  }

  return QUALITY;
}

export default {
  components: { AppNotification },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      docOpened: false,
      docUrl: '',
      docId: '',
      kycSubmissionFormOpened: false,
      resizedFileBlob: undefined,
      kycSubmissionFormDocsSetId: '',
      kycSubmissionFormDocId: '',
    };
  },
  methods: {
    /* eslint-enable */
    openKycDoc(docId, docUrl) {
      this.docOpened = true;
      this.docUrl = docUrl;
      this.docId = docId;
    },
    closeKycDoc() {
      this.docOpened = false;
      this.docUrl = '';
      this.docId = '';
    },
    /* eslint-enable */
    openKycSubmissionForm() {
      this.kycSubmissionFormOpened = true;
    },
    closeKycSubmissionForm() {
      this.kycSubmissionFormOpened = false;
    },
    refetchGetUserKycStatus() {
      return [{
        query: getUserKycStatus,
        variables: {
          userId: this.userId,
        },
      }];
    },
    refetchCheckKycBeforeWithdraw() {
      return [{
        query: checkKycBeforeWithdraw,
        variables: {
          userId: this.userId,
        },
      }];
    },
    onFileLoad(file) {
      console.log({ file });
      this.resizedFileBlob = undefined;

      if (file) {
        const canvas = document.getElementById('canvas');

        if (!file) {
          return;
        }

        const fr = new FileReader();

        fr.onload = () => {
          if (!fr.result) {
            return;
          }

          const img = new Image();

          img.onload = () => {
            const ctx = canvas?.getContext('2d');

            if (canvas && ctx) {
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0, img.width, img.height);

              canvas.toBlob(
                blob => {
                  this.resizedFileBlob = blob ?? undefined;
                },
                'image/jpeg',
                qualityRate(file.size),
              );
            }
          };

          if (typeof fr.result === 'string') {
            img.src = fr.result;
          }
        }; // onload fires after reading is complete

        fr.readAsDataURL(file);
      }
    },
    async uploadKycDoc() {
      if (this.resizedFileBlob) {
        console.log('resizedFileBlob', this.resizedFileBlob);

        const data = await this.$apollo.mutate({
          // eslint-disable-next-line global-require
          mutation: require('../graphql/mutations/getPostKycDocPolicy.graphql'),
          variables: {
            userId: this.userId,
            docsSetId: this.kycSubmissionFormDocsSetId,
            docId: this.kycSubmissionFormDocId,
          },
        });

        console.log('data', data);

        const formDataToSend = new FormData();

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(data.data.getPostKycDocPolicy.formData)) {
          formDataToSend.append(key, value);
        }

        formDataToSend.append('file', this.resizedFileBlob);

        const fetchData = await fetch(data.data.getPostKycDocPolicy.postURL, {
          method: 'post',
          body: formDataToSend,
        });

        if (fetchData.ok) {
          this.resizedFileBlob = undefined;

          const canvas = document.getElementById('canvas');
          const ctx = canvas.getContext('2d');

          ctx.clearRect(0, 0, canvas.width, canvas.height);

          const fileInput = document.getElementById('file');

          fileInput.value = '';

          await this.$apollo.mutate({
            // eslint-disable-next-line global-require
            mutation: require('../graphql/mutations/submitKycDocBeforeWithdraw.graphql'),
            variables: {
              userId: this.userId,
              docsSetId: this.kycSubmissionFormDocsSetId,
              docId: this.kycSubmissionFormDocId,
              value: '',
            },
            refetchQueries: this.refetchCheckKycBeforeWithdraw,
          });

          this.kycSubmissionFormDocId = undefined;
        }
      }
    },
    setKycSubmissionFormParams(data) {
      if (!data || !data.checkKycBeforeWithdraw || !data.checkKycBeforeWithdraw.docsSetIdToSubmit) return;

      this.kycSubmissionFormDocsSetId = data.checkKycBeforeWithdraw.docsSetIdToSubmit;
      // eslint-disable-next-line prefer-destructuring
      this.kycSubmissionFormDocId = data.checkKycBeforeWithdraw.photoDocsToSubmit[0];
    },
  },
};
</script>
